module.exports = __webpack_public_path__ + "static/media/header.6d86e597.png";